// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navigation-tabs[data-v-0d51675d] {\n  width: calc(100% - 50px);\n  top: 50px;\n}\n@media (min-width: 768px) {\n.navigation-tabs[data-v-0d51675d] {\n    width: calc(100% - 200px);\n    top: 72px;\n}\n}\n.tab[data-v-0d51675d] {\n  padding: 20px 40px;\n}\n.white-bottom-border[data-v-0d51675d] {\n  border-bottom: 2px solid white;\n}\n.active-tab[data-v-0d51675d] {\n  border-bottom: 2px solid #9d0007;\n}", ""]);
// Exports
module.exports = exports;
